import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "row-asin-list"
};
var _hoisted_2 = {
  class: "text"
};
var _hoisted_3 = ["src"];
import { ref, shallowRef, onMounted, computed } from 'vue';
import AsinItem from './AsinItem.vue';
import { getAsinBatch } from '@/models/api/detailPageApi';
import { useLess } from '@/models/hooks';
import constants, { encryptedMarketplaceId } from '@/constants';
import { jumpInteractionType } from '@/utils/common';
import { batchGetAsinsData } from '@/utils/landingPageCommon';
import { useRouter } from 'vue-router';
import { DISPLAY_MODE } from '@/configs/views/landingPage.js';
var API_MAX_ASINS_LENGTH = 20;
export default {
  __name: 'VerticalAsinShowCase',
  props: {
    asinClass: {
      type: String
    },
    asinIds: {
      type: Array
    },
    isWaterfallFlow: {
      type: Boolean
    },
    layoutType: {
      type: String
    },
    asinBadge: {
      type: String
    },
    isShowBuyButton: {
      type: Boolean
    },
    displayQuantity: {
      type: Number
    },
    moreIsShow: {
      type: Boolean
    },
    customTextContent: {
      type: String
    },
    interactionTypeInfo: {
      type: Array
    }
  },
  emits: ['onClickBuyPop'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/landingPage/asinShowcase/RowAsinList.less');
    var router = useRouter();
    var isLoading = ref(false);
    var isFinished = ref(false);
    var dataPagination = shallowRef(0);
    var count = shallowRef(10);
    var asinList = ref([]);
    var cptAsinItemStyle = computed(() => {
      return _objectSpread({}, !props.isShowBuyButton && {
        height: 'auto'
      });
    });
    var loadAsinList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var asinIdList, length, asinIdListCopy, _data, _yield$getAsinBatch, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isLoading.value = true;
              if (!(!props.asinIds || !props.asinIds.length)) {
                _context.next = 5;
                break;
              }
              isFinished.value = true;
              isLoading.value = false;
              return _context.abrupt("return");
            case 5:
              asinIdList = [];
              if (!(props.layoutType === DISPLAY_MODE.NORMAL)) {
                _context.next = 12;
                break;
              }
              length = props.displayQuantity > props.asinIds.length ? props.asinIds.length : props.displayQuantity;
              asinIdList = props.asinIds.slice(0, length);
              isFinished.value = true;
              _context.next = 19;
              break;
            case 12:
              if (!(dataPagination.value * count.value >= props.asinIds.length)) {
                _context.next = 16;
                break;
              }
              isFinished.value = true;
              isLoading.value = false;
              return _context.abrupt("return");
            case 16:
              asinIdListCopy = JSON.parse(JSON.stringify(props.asinIds));
              asinIdList.push(...asinIdListCopy.slice(dataPagination.value * count.value, (dataPagination.value + 1) * count.value));
              dataPagination.value += 1;
            case 19:
              if (!(asinIdList.length > API_MAX_ASINS_LENGTH)) {
                _context.next = 23;
                break;
              }
              try {
                // Fragment request, previous request completed, next request
                batchGetAsinsData(asinIdList, API_MAX_ASINS_LENGTH, asinList);
              } catch (error) {
                console.error(error, 'api---getAsinBatch---error');
              } finally {
                isLoading.value = false;
              }
              _context.next = 38;
              break;
            case 23:
              _context.prev = 23;
              _context.next = 26;
              return getAsinBatch({
                ids: asinIdList.join(','),
                marketplace: encryptedMarketplaceId,
                withCache: true
              });
            case 26:
              _yield$getAsinBatch = _context.sent;
              data = _yield$getAsinBatch.data;
              data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(i => {
                var _i$availability;
                return i.selectionEligible && ((_i$availability = i.availability) === null || _i$availability === void 0 ? void 0 : _i$availability.status) !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK;
              });
              asinList.value.push(...data);
              _context.next = 35;
              break;
            case 32:
              _context.prev = 32;
              _context.t0 = _context["catch"](23);
              console.error(_context.t0, 'api---getAsinBatch---error');
            case 35:
              _context.prev = 35;
              isLoading.value = false;
              return _context.finish(35);
            case 38:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[23, 32, 35, 38]]);
      }));
      return function loadAsinList() {
        return _ref.apply(this, arguments);
      };
    }();
    var onClickBuyPop = item => {
      emit('onClickBuyPop', {
        merchantId: item.merchantId,
        selectedAsin: item.selectedAsin
      });
    };
    var handleSeeMore = () => {
      var _props$interactionTyp;
      jumpInteractionType(props === null || props === void 0 ? void 0 : (_props$interactionTyp = props.interactionTypeInfo) === null || _props$interactionTyp === void 0 ? void 0 : _props$interactionTyp[0], router);
    };
    onMounted(() => {
      loadAsinList();
    });
    return (_ctx, _cache) => {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
        loading: isLoading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => isLoading.value = $event),
        finished: isFinished.value,
        "loading-text": _ctx.$t('modules.commonComponent.pullRefresh.LOADING'),
        onLoad: loadAsinList
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinList.value, asinItem => {
          return _openBlock(), _createBlock(AsinItem, {
            style: _normalizeStyle(cptAsinItemStyle.value),
            class: _normalizeClass([__props.asinClass, 'asin-item']),
            key: asinItem.id,
            asinItem: asinItem,
            asinBadge: __props.asinBadge,
            isShowBuyButton: __props.isShowBuyButton,
            onOnClickBuyPop: onClickBuyPop
          }, null, 8, ["style", "class", "asinItem", "asinBadge", "isShowBuyButton"]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "loading-text"]), !__props.isWaterfallFlow && __props.moreIsShow ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "show-more",
        onClick: handleSeeMore
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.customTextContent), 1), _createElementVNode("img", {
        src: `${_unref(constants).IMAGE_URL}assets/image/icons/rightArrowGrey.png`,
        alt: ""
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true)]);
    };
  }
};